export const LOAD_NEWS = "LOAD_NEWS";
export const LOAD_NEWS_SLIDER = "LOAD_NEWS_SLIDER";
export const GET_NEW_BY_ID = "GET_NEW_BY_ID";
